import { render } from "./GridSection.vue?vue&type=template&id=2bc98021&scoped=true"
import script from "./GridSection.vue?vue&type=script&lang=js"
export * from "./GridSection.vue?vue&type=script&lang=js"

import "./GridSection.vue?vue&type=style&index=0&id=2bc98021&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc98021"]])

export default __exports__